var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.811 9.08573L17.5013 8.75303C16.9883 8.20197 16.156 8.20197 15.643 8.75303L11.0585 13.6772L9.97908 12.5177C9.46609 11.9666 8.63375 11.9666 8.12076 12.5177L7.81104 12.8504L11.0585 16.3397L17.811 9.08573Z",
    fill: "#03824F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.811 21.3397C17.7816 21.3397 21.811 17.3103 21.811 12.3397C21.811 7.36913 17.7816 3.33969 12.811 3.33969C7.84047 3.33969 3.81104 7.36913 3.81104 12.3397C3.81104 17.3103 7.84047 21.3397 12.811 21.3397ZM12.811 23.3397C18.8862 23.3397 23.811 18.4148 23.811 12.3397C23.811 6.26456 18.8862 1.33969 12.811 1.33969C6.7359 1.33969 1.81104 6.26456 1.81104 12.3397C1.81104 18.4148 6.7359 23.3397 12.811 23.3397Z",
    fill: "#03824F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.d8e8a97fc8b0c0198376b1914fbdf4d8.svg";
export { ForwardRef as ReactComponent };